<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
  <div class="form-group form-row mx-1">
  <label mat-raised-button [matTooltip]="infoBulle" matTooltipClass="tooltip-large" [matTooltipPosition]="positionIB" [for]="idHtml" [class]="'form-label my-auto ' + classeColLabel + ' ' + classeSupplLabel">{{libelle$ | async}}
      <i *ngIf="infoBulle !== ''"  class="material-icons md-dark md-18"
      aria-hidden="true">
      info
      </i>
  </label>
  <div [class]="'input-group ' + classeColInput">
      <div class="input-group-preprend" *ngIf="prefixe">
        <span class="input-group-text">{{prefixe}}</span>
      </div>
      <input [readOnly]="afficherEnLectureSeule" (keyup)="scroll(target)" bisKeypadNavigation [max]="max" type="text" min="0" (blur)="onBlur()" [class]="'form-control ' + classeSupplInput"
        [class.is-warning]="aErreurCroiseeActive()"
        [class.is-invalid]="champInvalide()" [class.is-valid]="champValide()" [formControlName]="labelAffichage"
        [id]="idHtml">
    </div>
    <bis-affiche-erreurs [class]="classeLabelErreur" *ngIf="erreursAffichable()" [erreurs]="rootForm.get(label).errors">
    </bis-affiche-erreurs>
    <div #target></div>
  </div>
</form>
